import React, { useState } from 'react';

import { Modal } from 'antd';

import isBefore from 'date-fns/isBefore';

import { Icon } from '@eduzz/ui-antd-theme';

import {
  idsModalInadimplencia,
  idsModalOrderBump,
  idsModaLowTicket,
  idsModalRvp,
  idsModalSubscription,
  idsModalUpsell
} from './IdsShowModal';

const arrayModais: {
  users: number[];
  image: string;
  link: string;
  closeIconClassName: string;
}[] = [
  {
    users: idsModalInadimplencia,
    image: '/img/activation-campaign/recuperacao-inadimplencia.svg',
    link: 'https://my2.eduzz.com/subscriptions/mass-charge',
    closeIconClassName: 'text-white'
  },
  {
    users: idsModalSubscription,
    image: '/img/activation-campaign/subscriptions.svg',
    link: 'https://orbita.eduzz.com/producer/product/newproduct',
    closeIconClassName: 'text-white'
  },
  {
    users: idsModalOrderBump,
    image: '/img/activation-campaign/orderbump.svg',
    link: 'https://sun-admin.eduzz.com/orderbump',
    closeIconClassName: 'text-black'
  },
  {
    users: idsModaLowTicket,
    image: '/img/activation-campaign/low-ticket.svg',
    link: 'https://orbita.eduzz.com/producer/product/newproduct',
    closeIconClassName: 'text-black'
  },
  {
    users: idsModalRvp,
    image: '/img/activation-campaign/rvp-internal.svg',
    link: 'https://ajuda.eduzz.com/hc/pt-br/articles/1260807625289-como-funciona-o-recuperador-de-vendas-eduzz',
    closeIconClassName: 'text-black'
  },
  {
    users: idsModalUpsell,
    image: '/img/activation-campaign/upsell.svg',
    link: 'https://ajuda.eduzz.com/hc/pt-br/articles/1260807654450-o-que-%C3%A9-um-upsell-one-click-buy-e-como-configur%C3%A1-lo-no-checkout-sun',
    closeIconClassName: 'text-black'
  }
];

export default function ActivationCampaign({ userId }: { userId: number }) {
  const campaignStorageName = 'activation-campaign-seen-04-2026';
  const alreadySeen = JSON.parse(localStorage.getItem(campaignStorageName));
  const [open, setOpen] = useState(!alreadySeen);
  const isCampaignAtive = isBefore(new Date(), new Date('2026-05-13'));
  const modalSelected = arrayModais.find(item => item.users.includes(userId));

  const handleClose = () => {
    setOpen(false);
    localStorage.setItem(campaignStorageName, 'true');
  };

  if (!modalSelected || !isCampaignAtive) {
    return null;
  }

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      centered
      footer={null}
      closable={false}
      width='min(98vw, 700px)'
      classNames={{
        content: 'rounded-none bg-transparent p-0 shadow-none!',
        body: 'overflow-visible p-0'
      }}
    >
      <div className='relative aspect-square w-full'>
        <img src={modalSelected.image} alt='' aria-hidden className='block size-full object-cover object-center' />

        <a href={modalSelected.link} target='_blank' rel='noreferrer' className='absolute inset-0 block' />

        <button
          type='button'
          aria-label='Fechar'
          onClick={handleClose}
          className={`absolute top-6.5 right-8 z-10 cursor-pointer border-0 bg-transparent p-0 ${modalSelected.closeIconClassName}`}
        >
          <Icon.X size={20} />
        </button>
      </div>
    </Modal>
  );
}
